import React from 'react';
import StickyFooter from 'react-sticky-footer';

export default class fixedFooter extends React.Component {
  render() {
    return (
      <StickyFooter bottomThreshold={50} stickyStyles={{width:'100%'}}>
        <div className="bg-purple text-white">
          {this.props.children}
        </div>
      </StickyFooter>
    );
  }
}
